export const createRandomString = (length: number) => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let uid = "";

    for (let i = 0; i < length - 2; i += 1) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        uid += characters.charAt(randomIndex);
    }

    return `CA${uid}`;
};
